import React from 'react';
import { navigate } from 'gatsby';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../../../components-core/packages/components-core/dist/container/index';

import { Button, ButtonAppearance } from '../../../../../components-core/packages/components-core/dist/button';

import { IntegratorRoot } from '../../../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../../../components-core/packages/components-core/dist/helpers';
import { AspectRatioContainer, AspectRatio } from '../../../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../../../components-core/packages/components-core/dist/image/index';
import { FixedWidthContainer } from '../../../../../components-core/packages/components-core/dist/fixed-width-container/index';
import { BreakpointWrapper } from '../../../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { Link } from '../../../../../components-core/packages/components-core/dist/link/index';
import { TableHeader } from '../../../price-list/inner-components/table-header/TableHeader'
import { ArrowRight } from '../../../../../components-core/packages/icons-core/dist/ArrowRight/index';

import PriceTable from '../../inner-components/price-table/PriceTable';
import OptionalAccordion from '../../../optional-accordion/OptionalAccordion'
import PriceCard from '../../inner-components/price-card/PriceCard';
//CUSTOM COMPONENTS
import { TopContainer } from '../../../../helpers/ComponentHelpers';
import amarok from '../../inner-components/horizontal-car-list/amarok.png';
import caddy from '../../inner-components/horizontal-car-list/caddy.png';
import crafter from '../../inner-components/horizontal-car-list/crafter.png';
import transporter from '../../inner-components/horizontal-car-list/transporter.png';
import amarokActive from '../../inner-components/horizontal-car-list/amarok-active.png';
import caddyActive from '../../inner-components/horizontal-car-list/caddy-active.png';
import transporterActive from '../../inner-components/horizontal-car-list/transporter-active.png'
import crafterActive from '../../inner-components/horizontal-car-list/crafter-active.png'
import Layout from '../../../layout';
import LayoutTwo from '../../../layouttwo'

/**
 * Yatay olarak kaydırma yapabilmemiz için VW Core-Components yeterli olmadığı için
 * kendi containerlarımızı yazmak durumundayız.
 */
const HorizontalScrollableContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    align-items: center;
`;

const CarContainer = styled.div`
    flex: 0 0 auto;
    cursor: pointer;
`;

const SelectedLine = styled.div`
    width: 100%;
    height: 2px;
    background-color: #00437a;
    display: ${props => props.isSelected ? 'block' : 'none'};
`;


const TopContainerPrice = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;



class HorizontalCarList extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: 0,
            updatingPage: 0,
        }
    }

    renderTitle() {
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;
        if (isMobile) {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        Fiyatlarımızı&nbsp;<br />
                        <Text bold appearance={TextAppearance.headline0400} >
                            güncelliyoruz
                        </Text>
                    </Text></h2>
                </Container>
            )
        } else {
            return (
                <Container
                    padding={padding4Dimensions}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <h2><Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                        Fiyatlarımızı&nbsp;
                    <Text bold appearance={TextAppearance.headline0400} >
                            güncelliyoruz
                    </Text>
                    </Text></h2>
                </Container>
            )
        }

    }

    renderDescription() {

        return (
            <Container
                padding={padding4Dimensions}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200}>
                    Bu sırada modellerimizi inceleyebilirsiniz.
                </Text>
            </Container>
        )
    }

    renderButton() {

        return (
            <Container
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Button appearance={ButtonAppearance.Primary} onClick={() => navigate('https://ticariarac.vw.com.tr/modeller/')}>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                        Modelleri İncele
                    </Text>
                </Button>
            </Container>
        )
    }

    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Container
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderDescription()}
                    {this.renderButton()}
                </Container>
            </Container>
        )
    }

    renderCars() {
        const datasetLength = dummyArray.length;
        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;


        if (isMobile) {
            return dummyArray.map((item, index) =>
                <CarContainer onClick={() => this.setState({ selectedIndex: index })}>
                    <Container padding={carContainerPadding(index, datasetLength)}>
                        <FixedWidthContainer columns={fixedWidthContainerAppearance}>
                            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.static200}>
                                {index === this.state.selectedIndex ? <Image width="64px" height="30px" src={item.activeImage} alt={item.img} /> : <Image src={item.img} alt={item.img} />}
                                <Container stretchContent={true} wrap={ContainerWrap.always}>
                                    {(item.name === 'Transporter') ? <Text
                                        appearance={TextAppearance.copy0100}
                                        bold={true}
                                    >
                                        <Link>{item.name}</Link>
                                    </Text> : <Text
                                        appearance={TextAppearance.copy0100}
                                        textAlign={TextAlignment.center}
                                        bold={true}
                                    >
                                            <Link>{item.name}</Link>
                                        </Text>}
                                    <SelectedLine isSelected={this.state.selectedIndex === index} />
                                </Container>
                            </Container>
                        </FixedWidthContainer>
                    </Container>
                </CarContainer>
            )
        } else {
            return dummyArray.map((item, index) =>
                <CarContainer onClick={() => this.setState({ selectedIndex: index })}>
                    <Container padding={carContainerPadding(index, datasetLength)}>
                        <FixedWidthContainer columns={fixedWidthContainerAppearance}>
                            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.static200}>
                                {index === this.state.selectedIndex ? <Image src={item.activeImage} alt={item.img} /> : <Image src={item.img} alt={item.img} />}
                                <Container stretchContent={true} wrap={ContainerWrap.always}>
                                    <Text
                                        appearance={TextAppearance.copy0150}
                                        textAlign={TextAlignment.center}
                                        bold={true}
                                    >
                                        <Link>{item.name}</Link>
                                    </Text>
                                    <SelectedLine isSelected={this.state.selectedIndex === index} />
                                </Container>
                            </Container>
                        </FixedWidthContainer>
                    </Container>
                </CarContainer>

            )
        }

    }

    render() {
        if (this.state.updatingPage) {
            return (
                <LayoutTwo theme={'main'}>
                    <div style={{ marginTop: '100px' }}>

                        <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>
                            <ThemeProvider theme={'main'}>
                                <Container wrap={ContainerWrap.never} stretchContent={true}>
                                    <TopContainerPrice>
                                        {this.renderInnerContainer()}
                                    </TopContainerPrice>
                                </Container>
                            </ThemeProvider>
                        </Container>
                    </div>
                </LayoutTwo>
            )
        } else {
            return (
                <LayoutTwo theme={'main'}>
                    <div style={{ marginTop: '100px' }}>
                        <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}>

                            <ThemeProvider theme={'main'}>
                                <Container wrap={ContainerWrap.never} stretchContent={true}>
                                    <BreakpointWrapper max={Breakpoints.b960}>
                                        <HorizontalScrollableContainer>
                                            {this.renderCars()}
                                        </HorizontalScrollableContainer>
                                    </BreakpointWrapper>

                                    <BreakpointWrapper min={Breakpoints.b960}>
                                        <Container horizontalAlign={ContainerHorizontalAlignment.center}>

                                            {this.renderCars()}
                                        </Container>
                                    </BreakpointWrapper>
                                </Container>
                            </ThemeProvider>
                            {this.renderPriceList(this.state.selectedIndex)}
                        </Container>
                    </div>
                </LayoutTwo>

            )
        }

    }

    renderPriceText() {
        return (
            <Container horizontalAlign={ContainerHorizontalAlignment.center} padding={ContainerPadding.static200}
            ><Text
                appearance={TextAppearance.headline350}
                textAlign={TextAlignment.center}
            >Fiyat Listeleri</Text></Container>
        )
    }


    renderPriceList(selectedIndex) {

        const {custom,custom1,custom2,custom3,custom4,custom5,custom6,custom7,custom8,custom9,custom10,custom11,custom12,custom13,custom14,custom15} =  this.props;


        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        const caddyOptional = {
            title: 'Caddy Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            caddyOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '3.500 TL'
                },
                {
                    'title': 'Panaromik Cam Tavan',
                    'description': '10.000 TL'
                },
            ]
        }

        const transporterOptional = {
            title: 'Transporter Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            transporterOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '5.000 TL'
                },
                {
                    'title': 'Otomatik Vites*',
                    'description': '17.000 TL'
                },
            ]
        }

        const amarokOptional = {
            title: 'Amarok Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            amarokOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '2.750 TL'
                },
                {
                    'title': 'Mekanik Diferansiyel Kilidi',
                    'description': '4.199 TL'
                },
            ]
        }

        const crafterOptional = {
            title: 'Crafter Opsiyonlar',
            price: '0000',
            description: 'Kampanyalı anahtar teslim fiyatı',
            crafterOptionalDetails: [
                {
                    'title': 'Metalik Renk',
                    'description': '10.000 TL'
                },
                {
                    'title': 'Otomatik Şanzıman',
                    'description': '15.000 TL'
                },
                {
                    'title': '177 PS motor (Panelvan)',
                    'description': '16.000 TL'
                },
                {
                    'title': '4Motion(Panelvan)',
                    'description': '35.000 TL'
                },
                {
                    'title': 'Klima (Panelvan)',
                    'description': '11.361 TL'
                },
                {
                    'title': 'Led Farlar(Panelvan)',
                    'description': '9.780 TL'
                },
                {
                    'title': 'Şerit Takip Sistemi',
                    'description': '4.234 TL'
                },
                {
                    'title': 'OYA 3 Noktadan Gergili Emniyet Kemeri (16+1 Servis)',
                    'description': '4.300 TL'
                },
                {
                    'title': 'OYA 3 Noktadan Gergili Emniyet Kemeri (19+1 Servis)',
                    'description': '5.100 TL'
                },
            ]
        }

        const caddyModels = {
            title: 'Caddy Modeller',
            description: 'Anahtar ve Kampanyalı teslim fiyatları',
            caddyImpressionDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '234.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '224.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '164.283 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '24.643 TL'
                },
                {
                    'title': 'KDV',
                    'description': '34.007 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyImptessionDSGDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '251.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '241.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '176.811 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '26.522 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.600 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyLifeDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '251.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '241.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '176.811 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '26.522 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.600 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyLifeDSGDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '268.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '258.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '189.339 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '28.401 TL'
                },
                {
                    'title': 'KDV',
                    'description': '39.193 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyStyleDSGDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '289.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '279.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '204.814 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '30.722 TL'
                },
                {
                    'title': 'KDV',
                    'description': '42.396 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyCargo122PSDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '180.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '172.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '139.390 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '5.576 TL'
                },
                {
                    'title': 'KDV',
                    'description': '26.094 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],

            caddyCargo122PSDSGDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '197.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '189.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '153.243 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.130 TL'
                },
                {
                    'title': 'KDV',
                    'description': '28.687 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyCargoMaxi122PSDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '184.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '176.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '142.650 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '5.706 TL'
                },
                {
                    'title': 'KDV',
                    'description': '26.704 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caddyCargoMaxi122PSDSGDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '201.900 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '193.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '156.502 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.260 TL'
                },
                {
                    'title': 'KDV',
                    'description': '29.297 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trCityVanStandartSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '262.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '248.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '181.306 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '27.196 TL'
                },
                {
                    'title': 'KDV',
                    'description': '37.530 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trCityVanUzunSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '278.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '263.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '192.728 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '28.909 TL'
                },
                {
                    'title': 'KDV',
                    'description': '39.895 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trPanelVanStandartSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '216.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '204.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '164.732 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.589 TL'
                },
                {
                    'title': 'KDV',
                    'description': '30.838 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trPanelVanUzunSasiModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '222.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '210.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '169.622 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.785 TL'
                },
                {
                    'title': 'KDV',
                    'description': '31.753 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trPanelVanUzunSasi150ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '237.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '224.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '181.437 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.257 TL'
                },
                {
                    'title': 'KDV',
                    'description': '33.965 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trPikapTekKabinModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '218.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '206.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '166.362 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '6.654 TL'
                },
                {
                    'title': 'KDV',
                    'description': '31.143 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            trPikapCiftKabinModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '232.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '219.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '177.259 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.090 TL'
                },
                {
                    'title': 'KDV',
                    'description': '33.183 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.268 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caraComfortLineUzunSasi110ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '337.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '322.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '236.310 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '35.446 TL'
                },
                {
                    'title': 'KDV',
                    'description': '48.916 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caraComfortLineUzunSasi150ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '374.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '353.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '259.522 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '38.928 TL'
                },
                {
                    'title': 'KDV',
                    'description': '53.721 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caraComfortLineUzunSasi150DSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '395.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '374.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '274.998 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '41.250 TL'
                },
                {
                    'title': 'KDV',
                    'description': '56.925 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caraHighlineUzunSasi199DSGModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '466.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '443.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '325.477 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '48.822 TL'
                },
                {
                    'title': 'KDV',
                    'description': '67.374 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            caraHighlineUzunSasi199DSG4MotionModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '530.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '504.900 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '369.302 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '55.395 TL'
                },
                {
                    'title': 'KDV',
                    'description': '76.446 TL'
                },
                {
                    'title': 'MTV',
                    'description': '3.057 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterServis16ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '385.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '361.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '293.083 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.723 TL'
                },
                {
                    'title': 'KDV',
                    'description': '54.865 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterServis19ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '396.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '373.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '302.081 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.083 TL'
                },
                {
                    'title': 'KDV',
                    'description': '56.550 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.586 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterOkul16ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '413.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '390.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '316.714 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.669 TL'
                },
                {
                    'title': 'KDV',
                    'description': '59.289 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterOkul19ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '425.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '401.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '325.305 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '13.012 TL'
                },
                {
                    'title': 'KDV',
                    'description': '60.897 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.586 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterPanelVanMWBModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '247.500 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '230.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '185.919 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.437 TL'
                },
                {
                    'title': 'KDV',
                    'description': '34.804 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],

            crafterPanelVanLWBModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '256.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '238.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '192.845 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '7.714 TL'
                },
                {
                    'title': 'KDV',
                    'description': '36.101 TL'
                },
                {
                    'title': 'MTV',
                    'description': '1.141 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],

            amarokHighlineModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '400.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '321.043 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.842 TL'
                },
                {
                    'title': 'KDV',
                    'description': '60.099 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.371 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            amarokCanyonModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '416.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '334.089 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '13.364 TL'
                },
                {
                    'title': 'KDV',
                    'description': '62.542 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.860 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],
            crafterServis15ModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '375.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '357.000 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '289.824 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '11.593 TL'
                },
                {
                    'title': 'KDV',
                    'description': '54.255 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],
            crafterOkul16LWBComfortline: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '404.000 TL'
                },
                {
                    'title': 'Kampanyalı Anahtar Teslim Fiyatı',
                    'description': '386.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '313.862 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '12.554 TL'
                },
                {
                    'title': 'KDV',
                    'description': '58.755 TL'
                },
                {
                    'title': 'MTV',
                    'description': '628 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '353 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '347 TL'
                },
            ],

            amarokAventuraModelsDetails: [
                {
                    'title': 'Anahtar Teslim Fiyatı',
                    'description': '519.500 TL'
                },
                {
                    'title': 'Net Fiyat',
                    'description': '418.020 TL'
                },
                {
                    'title': 'ÖTV',
                    'description': '16.721 TL'
                },
                {
                    'title': 'KDV',
                    'description': '78.253 TL'
                },
                {
                    'title': 'MTV',
                    'description': '5.860 TL'
                },
                {
                    'title': 'TTİ Resmi Bedeli*',
                    'description': '314 TL'
                },
                {
                    'title': 'TTİ Hizmet Bedeli*',
                    'description': '332 TL'
                },
            ],

        }


        if (isMobile) {
            if (selectedIndex === 0) {

                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                            <div style={{float:'left'}}><Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></div></Container>
                        <br />
                        
                        <PriceCard data={caddyModels.caddyStyleDSGDetails} carName={'Yeni Caddy Style'} modelNameOne={'Yeni Caddy 2.0 TDI 122 PS Style DSG'} kafone={'279.900'} containerColor={'#b99e8c'} carImage={1} /><br />
                        <PriceCard data={caddyModels.caddyLifeDetails} dataTwo={caddyModels.caddyLifeDSGDetails} modelNameOne={'Yeni Caddy 2.0 TDI 122 PS Life'} modelNameTwo={'Yeni Caddy 2.0 TDI 122 PS Life DSG'} kafone={'241.900'} kaftwo={'258.900'} carName={'Yeni Caddy Life'} containerColor={'#1a6789'} carImage={2} /><br />
                        <PriceCard data={caddyModels.caddyImpressionDetails} dataTwo={caddyModels.caddyImptessionDSGDetails} modelNameOne={'Yeni Caddy 2.0 TDI 122 PS Impression'} modelNameTwo={'Yeni Caddy 2.0 TDI 122 PS Impression DSG'} carName={'Yeni Caddy Impression'} kafone={'224.900'} kaftwo={'241.900'} containerColor={'#bebebe'} carImage={3} /><br />
                        <PriceCard data={caddyModels.caddyCargo122PSDetails} dataTwo={caddyModels.caddyCargo122PSDSGDetails} dataThree={caddyModels.caddyCargoMaxi122PSDetails} dataFour={caddyModels.caddyCargoMaxi122PSDSGDetails} modelNameOne={'Yeni Caddy Cargo 2.0 TDI 122 PS'} modelNameTwo={'Yeni Caddy Cargo 2.0 TDI 122 PS DSG'} modelNameThree={'Yeni Caddy Cargo Maxi 2.0 TDI 122 PS'} modelNameFour={'Yeni Caddy Cargo Maxi 2.0 TDI 122 PS DSG'} carName={'Yeni Caddy Cargo'} kafone={'172.900'} kaftwo={'189.900'} kafthree={'176.900'} kaffour={'193.900'} containerColor={'#bebebe'} carImage={4} /><br />
                        <OptionalAccordion optional={caddyOptional.caddyOptionalDetails} />
                        {this.renderCaddyNotesTexts()}
                    </Container>

                )
            } else if (selectedIndex === 1) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                        <div style={{float:'left'}}><Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></div></Container>
                        <br />

                        <PriceCard data={caddyModels.trCityVanStandartSasiModelsDetails} dataTwo={caddyModels.trCityVanUzunSasiModelsDetails} carName={'Transporter Kombi'} modelNameOne={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Standart Şasi 150PS '} modelNameTwo={'Transporter City Van (5+1)/Camlı Van (4+1) 2.0 TDI Uzun Şasi 150PS'} kafone={'248.000'} kaftwo={'263.500'} containerColor={'#a0a0a0'} carImage={5} /><br />
                        <PriceCard data={caddyModels.trPanelVanStandartSasiModelsDetails} dataTwo={caddyModels.trPanelVanUzunSasiModelsDetails} dataThree={caddyModels.trPanelVanUzunSasi150ModelsDetails} modelNameOne={'Transporter Panel Van 2.0 TDI (2+1) Standart Şasi 110PS'} modelNameTwo={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 110PS '} modelNameThree={'Transporter Panel Van 2.0 TDI (2+1) Uzun Şasi 150PS'} kafone={'204.000'} kaftwo={'210.000'} kafthree={'224.500'} carName={'Transporter Panel Van'} containerColor={'#bebebe'} carImage={6} /><br />
                        <PriceCard data={caddyModels.trPikapTekKabinModelsDetails} dataTwo={caddyModels.trPikapCiftKabinModelsDetails} modelNameOne={'Transporter Pikap 2.0 TDI (2+1) Uzun Şasi Tek Kabin 110PS'} modelNameTwo={'Transporter Pikap 2.0 TDI (5+1) Uzun Şasi Çift Kabin 110PS'} carName={'Transporter Pikap'} kafone={'206.000'} kaftwo={'219.500'} containerColor={'#bebebe'} carImage={7} /><br />
                        <OptionalAccordion optional={transporterOptional.transporterOptionalDetails} />
                        {this.renderTransporterTexts()}
                    </Container>

                )
            } else if (selectedIndex === 2) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                        <div style={{float:'left'}}><Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></div></Container>
                        <br />
                        <PriceCard data={caddyModels.caraHighlineUzunSasi199DSGModelsDetails} dataTwo={caddyModels.caraHighlineUzunSasi199DSG4MotionModelsDetails} carName={'Caravelle Highline'} modelNameOne={'Caravelle Highline 2.0 TDI (8+1) Uzun Şasi 204 PS DSG'} modelNameTwo={'Caravelle Highline 2.0 TDI (8+1) Uzun Şasi 204 PS DSG 4Motion'} kafone={'443.000'} kaftwo={'504.900'} containerColor={'#990009'} carImage={9} /><br />
                        <PriceCard data={caddyModels.caraComfortLineUzunSasi150ModelsDetails} dataTwo={caddyModels.caraComfortLineUzunSasi150DSGModelsDetails} dataThree={caddyModels.caraComfortLineUzunSasi110ModelsDetails} carName={'Caravelle Comfortline'} modelNameOne={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS'} modelNameTwo={'Caravelle Comfortline 2.0 TDI Uzun Şasi 150PS DSG'} modelNameThree={'Caravelle Comfortline 2.0 TDI (8+1) Uzun Şasi 110 PS'} kafone={'353.500'} kaftwo={'374.500'} kafthree={'322.000'} containerColor={'#327396'} carImage={8} /><br />
                        {this.renderCaravelleTexts()}
                    </Container>

                )
            }
            else if (selectedIndex === 3) {
                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always} padding={{ top: '10px' }}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                        <div style={{float:'left'}}><Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></div></Container>
                        <br />
                        <PriceCard data={caddyModels.crafterServis16ModelsDetails} dataTwo={caddyModels.crafterServis19ModelsDetails} dataThree={caddyModels.crafterServis15ModelsDetails} modelNameThree={'Crafter Servis 2.0 TDI (15+1) LWB HR 140 PS Comfortline'} kafthree={'357.000'} kafone={'361.000'} kaftwo={'373.000'} carName={'Crafter Servis'} modelNameOne={'Crafter Servis 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} modelNameTwo={'Crafter Servis 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'} containerColor={'#91969d'} carImage={13} /><br />
                        <PriceCard data={caddyModels.crafterOkul16ModelsDetails} dataTwo={caddyModels.crafterOkul19ModelsDetails} dataThree={caddyModels.crafterOkul16LWBComfortline} containerColor={'#dedede'} kafone={'390.000'} kaftwo={'401.500'} kafthree={'386.500'} carName={'Crafter Okul'} modelNameOne={'Crafter Okul 2.0 TDI (16+1) ELWB HR 177 PS Comfortline'} modelNameTwo={'Crafter Okul 2.0 TDI (19+1) ELWB HR 177 PS Comfortline'} modelNameThree={'Crafter Okul 2.0 TDI (16+1) LWB HR 140 PS Comfortline'} carImage={14} /><br />
                        <PriceCard data={caddyModels.crafterPanelVanMWBModelsDetails} dataTwo={caddyModels.crafterPanelVanLWBModelsDetails} modelNameOne={'Crafter Panel Van 2.0 TDI (2+1) MWB HR 140 PS 3,5 T Comfortline'} modelNameTwo={'Crafter Panel Van 2.0 TDI (2+1) LWB HR 140 PS 3,5 T Comfortline'} containerColor={'#bebebe'} kafone={'230.000'} kaftwo={'238.500'} carName={'Crafter Panel Van'} carImage={15} /><br />
                        <OptionalAccordion optional={crafterOptional.crafterOptionalDetails} />
                        {this.renderCrafterTexts()}
                    </Container>

                )
            }

        } else {

            if (selectedIndex === 0) {

                return (

                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                            <Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></Container>
                        <br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.caddyStyleDSGDetails} carName={'Yeni Caddy Style'} carImage={1} carSource={custom}/><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.caddyLifeDetails} modelTwo={caddyModels.caddyLifeDSGDetails} carName={'Yeni Caddy Life'} carImage={2} carSource={custom1} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.caddyImpressionDetails} modelTwo={caddyModels.caddyImptessionDSGDetails} carName={'Yeni Caddy Impression'} carImage={3} carSource={custom2} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.caddyCargo122PSDetails} modelTwo={caddyModels.caddyCargo122PSDSGDetails} modelThree={caddyModels.caddyCargoMaxi122PSDetails} modelFour={caddyModels.caddyCargoMaxi122PSDSGDetails} carName={'Yeni Caddy Cargo'} carImage={4} carSource={custom3} /><br /><br />
                        <OptionalAccordion optional={caddyOptional.caddyOptionalDetails} />
                        {this.renderCaddyNotesTexts()}
                    </Container>

                )
            } else if (selectedIndex === 1) {

                return (
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                        <Container stretchContent={true} padding={topContainerPadding}>
                            <Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></Container>
                        <br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trCityVanStandartSasiModelsDetails} modelTwo={caddyModels.trCityVanUzunSasiModelsDetails} carName={'Transporter Kombi'} carImage={5} carSource={custom5} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trPanelVanStandartSasiModelsDetails} modelTwo={caddyModels.trPanelVanUzunSasiModelsDetails} modelThree={caddyModels.trPanelVanUzunSasi150ModelsDetails} carName={'Transporter Panel Van'} carImage={6} carSource={custom6} /><br /><br />
                        <PriceTable selectedIndex={selectedIndex} model={caddyModels.trPikapTekKabinModelsDetails} modelTwo={caddyModels.trPikapCiftKabinModelsDetails} carName={'Transporter Pikap'} carImage={7} carSource={custom7} /><br /><br />
                        <OptionalAccordion optional={transporterOptional.transporterOptionalDetails} />
                        {this.renderTransporterTexts()}
                    </Container>

                )
            }
            else if (selectedIndex === 2) {
                return (<Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                    <Container stretchContent={true} padding={topContainerPadding}>
                        <Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'}>tıklayınız </a></Text></Container>
                    <br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.caraHighlineUzunSasi199DSGModelsDetails} modelTwo={caddyModels.caraHighlineUzunSasi199DSG4MotionModelsDetails} carName={'Yeni Caravelle Highline'} carImage={9} carSource={custom9} /><br /><br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.caraComfortLineUzunSasi150ModelsDetails} modelTwo={caddyModels.caraComfortLineUzunSasi150DSGModelsDetails} modelThree={caddyModels.caraComfortLineUzunSasi110ModelsDetails} carName={'Caravelle Comfortline'} carImage={8} carSource={custom10} /><br /><br />
                    {this.renderCaravelleTexts()}
                </Container>)
            }
            else if (selectedIndex === 3) {
                return (<Container horizontalAlign={ContainerHorizontalAlignment.center} wrap={ContainerWrap.always}><br /><br />
                    <Container stretchContent={true} padding={topContainerPadding}>
                        <Text color={TextColor.secondary}>2020 fiyat listesi için <a href={'https://ticariarac.vw.com.tr/vwticari_files/2020.pdf'} target={'_blank'} >tıklayınız</a></Text></Container>
                    <br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterServis16ModelsDetails} modelTwo={caddyModels.crafterServis19ModelsDetails} modelThree={caddyModels.crafterServis15ModelsDetails} carName={'Crafter Servis'} carImage={13} carSource={custom12} /><br /><br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterOkul16ModelsDetails} modelTwo={caddyModels.crafterOkul19ModelsDetails} modelThree={caddyModels.crafterOkul16LWBComfortline} carName={'Crafter Okul'} carImage={14} carSource={custom13}/><br /><br />
                    <PriceTable selectedIndex={selectedIndex} model={caddyModels.crafterPanelVanMWBModelsDetails} modelTwo={caddyModels.crafterPanelVanLWBModelsDetails} carName={'Crafter Panel Van'} carImage={15} carSource={custom14}/><br /><br />
                    <OptionalAccordion optional={crafterOptional.crafterOptionalDetails} />
                    {this.renderCrafterTexts()}
                </Container>)
            }

        }


    }
    renderCaddyNotesTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br /> <br />1-Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber vermeksizin değişiklik yapma hakkını saklı tutar.<br /><br /></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 18/01/2021’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br /><br /></Text>
                <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir. <br /><br /></Text>
                <Text color={TextColor.secondary}>5- Menşei: Polonya <br /><br /></Text>

                <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV müşteriye aittir.<br /><br /></Text>
                <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir.<br /><br /></Text>
                <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca
ödenecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyat Maxi Van modeller için 2.852 TL, Kombi modeller için 2.579 TL’dir. Opsiyonel renk seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır.<br /><br /></Text>

            </Container>
        )
    }

    renderTransporterTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br /> <br />1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber
vermeksizin değişiklik yapma hakkını saklı tutar.<br /><br /></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 18.01.2021’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede
                belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle,
aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır.  <br /><br /></Text>
                <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
                gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın
vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>5- Menşei: Almanya, Polonya<br /><br /></Text>

                <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV
müşteriye aittir.<br /><br /></Text>
                <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü
                şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
                yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili
satıcıya değişkenlik gösterebilir.<br /><br /></Text>
                <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı Panel Van ve Pikap için 4.074TL, Camlı Van ve City Van için 3.685TL’dir. Opsiyonel renk
seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır.<br /><br /></Text>

            </Container>

        )
    }

    renderCaravelleTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br /> <br />1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber
vermeksizin değişiklik yapma hakkını saklı tutar.<br /><br /></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 18.01.2021’dir.Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede
                belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle,
aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br /><br /></Text>
                <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
                gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın
vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir. <br /><br /></Text>
                <Text color={TextColor.secondary}>5- Menşei: Almanya, Polonya<br /><br /></Text>

                <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV
müşteriye aittir. <br /><br /></Text>
                <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü
                şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
                yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili
satıcıya değişkenlik gösterebilir. <br /><br /></Text>
                <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br /><br /></Text>

            </Container>

        )
    }

    renderCrafterTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br /> <br />1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında önceden haber vermeksizin
değişiklik yapma hakkını saklı tutar<br /><br /></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 18.01.2021’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar geçerlidir. Listede belirtilen araçlar
                stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim
fiyatı değişebilecektir <br /><br /></Text>
                <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br /><br /></Text>
                <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik gösterebileceğinden, bu
                değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği olmaksızın vergi mevzuatından kaynaklı hesaplama
yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir<br /><br /></Text>
                <Text color={TextColor.secondary}>5- Menşei: Polonya<br /><br /></Text>
                <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu bedeller ve MTV müşteriye aittir. <br /><br /></Text>
                <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından
                yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet
bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir.<br /><br /></Text>
                <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca ödenecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı 8.149 TL’dir. Opsiyonel renk seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin 3 ve 5 no’lu dipnotlarındaki
açıklamalar geçerli olacaktır.<br /><br /></Text>

            </Container>
        )
    }

    renderAmarokTexts() {
        return (
            <Container stretchContent={true} padding={topContainerPadding}>
                <Text color={TextColor.secondary}><br /> <br />1- Doğuş Otomotiv üretim, ithalat gibi nedenlere bağlı olarak aracın model, standart ve opsiyonel aksesuarlarında, teknik özelliklerinde ve fiyatlarında
önceden haber vermeksizin değişiklik yapma hakkını saklı tutar.<br /><br /></Text>
                <Text color={TextColor.secondary}>2- Bu fiyat listesindeki fiyatların uygulanmaya başladığı tarih 18.01.2021’dir. Tavsiye edilen bu anahtar teslim fiyat listesi yenisi yayınlanana kadar
                geçerlidir. Listede belirtilen araçlar stoklarla sınırlıdır. Kesin sipariş verilmesi halinde ifa tarihinde yürürlükte olacak tavsiye edilen fiyat listesindeki
fiyatlar geçerli olacaktır. Bu nedenle, aracın tavsiye edilen anahtar teslim fiyatı değişebilecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>3- Burada belirtilen fiyatlar, standart donanımlı araçlara ait olup, opsiyonel ekipmanlar ve renkler ayrıca fiyatlandırılır. <br /><br /></Text>
                <Text color={TextColor.secondary}>4- Araca ilişkin her türlü vergi (ÖTV, KDV, MTV vb.), trafik tescil ve ruhsat işlemleri resmi bedelleri; resmi tarife değişikliklerine bağlı olarak değişkenlik
                gösterebileceğinden, bu değişikliklerden kaynaklanabilecek fiyat farkı / farkları müşteri tarafından karşılanacaktır. Bununla birlikte resmi tarife değişikliği
olmaksızın vergi mevzuatından kaynaklı hesaplama yöntemleri nedeniyle vergi tutarlarında farklar oluşabilecektir.  <br /><br /></Text>
                <Text color={TextColor.secondary}>5- Menşei: Almanya<br /><br /></Text>

                <Text color={TextColor.secondary}>6- Trafik tescil ve ruhsat işlemlerinin resmi bedeli, plaka basım bedeli, ruhsat basım bedeli, ruhsat tescil bedeli ve damga vergisinden ibaret olup, bu
bedeller ve MTV müşteriye aittir. <br /><br /></Text>
                <Text color={TextColor.secondary}>7- Trafik tescil ve ruhsat işlemleri müşteri tarafından veya müşterinin talebi halinde müşteriye vekaleten yetkili satıcı veya yetkili satıcının
                yetkilendireceği üçüncü şahıslar tarafından yapılabilmektedir. Müşterinin trafik tescil ve ruhsat işlemleri hizmetinin yetkili satıcı veya yetkili satıcının
                yetkilendireceği üçüncü şahıslar tarafından yapılmasını istemesi halinde, hizmet bedeli yetkili satıcı ile müşteri arasında belirlenir. Bu nedenle, trafik
tescil ve ruhsat işlemleri hizmet bedeli yetkili satıcıdan yetkili satıcıya değişkenlik gösterebilir.<br /><br /></Text>
                <Text color={TextColor.secondary}>8- Trafik sigorta poliçe bedeli yukarıda belirtilmiş olan tavsiye edilen anahtar teslim fiyatına dahil olmayıp, bu bedel müşteri tarafından ayrıca
ödenecektir.<br /><br /></Text>
                <Text color={TextColor.secondary}>9- Metalik renk seçeneği opsiyonel olup tavsiye edilen net fiyatı 2.241 TL’dir. Opsiyonel renk seçeneğinin araca eklenmesi durumunda, bu fiyat listesinin
3 ve 5 no’lu dipnotlarındaki açıklamalar geçerli olacaktır.<br /><br /></Text>

            </Container>
        )

    }
}
const carContainerPadding = (index, datasetLength) => ({
    left: {
        [Breakpoints.default]: index === 0 ? ContainerPadding.grid003 : ContainerPadding.dynamic0040,
        [Breakpoints.b960]: ContainerPadding.dynamic0020
    },
    right: {
        [Breakpoints.default]: index === datasetLength - 1 ? ContainerPadding.grid003 : ContainerPadding.dynamic0040,
        [Breakpoints.b960]: ContainerPadding.dynamic0020
    },
})

const fixedWidthContainerAppearance = {
    [Breakpoints.default]: 4,
    [Breakpoints.b560]: 4,
    [Breakpoints.tablet]: 2,
    [Breakpoints.b1280]: 2,
    [Breakpoints.b1920]: 1
}

const dummyArray = [
    {
        name: 'Caddy',
        img: caddy,
        activeImage: caddyActive
    },
    {
        name: 'Transporter',
        img: transporter,
        activeImage: transporterActive
    },
    {
        name: 'Caravelle',
        img: transporter,
        activeImage: transporterActive
    },
    {
        name: 'Crafter',
        img: crafter,
        activeImage: crafterActive
    }
]

const topContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b2560]: ContainerPadding.grid004
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b2560]: ContainerPadding.grid004
    }
}

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}



export default HorizontalCarList;